import { render, staticRenderFns } from "./EducationInput.vue?vue&type=template&id=69a59a14"
import script from "./EducationInput.vue?vue&type=script&lang=js"
export * from "./EducationInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports